import markerAsianEthnic from "../../assets/images/mark_asian_ethnic.png"
import markerBakery from "../../assets/images/mark_bakery.png";
import markerBar from "../../assets/images/mark_bar.png";
import markerCafe from "../../assets/images/mark_cafe.png";
import markerSweets from "../../assets/images/mark_sweets.png";
import markerCafeSweets from "../../assets/images/mark_cafe_sweets.png";
import markerChinese from "../../assets/images/mark_chinese.png";
import markerCurry from "../../assets/images/mark_curry.png";
import markerFastFood from "../../assets/images/mark_fast_food.png";
import markerInternational from "../../assets/images/mark_international.png";
import markerItalianFrench from "../../assets/images/mark_italian_french.png";
import markerIzakaya from "../../assets/images/mark_izakaya.png";
import markerJapanese from "../../assets/images/mark_japanese.png";
import markerNoodles from "../../assets/images/mark_noodles.png";
import markerOtherCuisine from "../../assets/images/mark_other_cuisine.png";
import markerWestern from "../../assets/images/mark_western.png";
import markerYakinikuTeppanyaki from "../../assets/images/mark_yakiniku_teppanyaki.png";
import {
    label_category_japanese, label_category_western, label_category_chinese,
    label_category_italian_french, label_category_asian_ethnic, label_category_izakaya,
    label_category_international, label_category_yakiniku_teppanyaki, label_category_curry,
    label_category_noodles, label_category_bar, label_category_bakery,
    label_category_cafe, label_category_sweets, label_category_cafe_sweets,
    label_category_fast_food
} from "../../assets/label/label";

// 緯度・経度を取得
export const getCoordinates = async (address) => {
    const geocoder = new window.google.maps.Geocoder();
    let lat = -1, lng = -1;

    try {
        const result = await new Promise((resolve, reject) => {
            geocoder.geocode({ address: address }, (response, status) => {
                if (status === "OK") {
                    resolve(response);
                } else {
                    reject("Geocode was not successful for the following reason: " + status);
                }
            });
        });
        lat = result[0].geometry.location.lat();
        lng = result[0].geometry.location.lng();
    } catch(error) {
        console.error(error);
    }
    return {lat, lng};
}

// マーカー画像の取得
export const getMarkerIcon = (category) => {
    switch (category) {
        case label_category_asian_ethnic:
            return markerAsianEthnic;
        case label_category_bakery:
            return markerBakery;
        case label_category_bar:
            return markerBar;
        case label_category_cafe:
            return markerCafe;
        case label_category_sweets:
            return markerSweets;
        case label_category_cafe_sweets:
            return markerCafeSweets;
        case label_category_chinese:
            return markerChinese;
        case label_category_curry:
            return markerCurry;
        case label_category_fast_food:
            return markerFastFood;
        case label_category_international:
            return markerInternational;
        case label_category_italian_french:
            return markerItalianFrench;
        case label_category_izakaya:
            return markerIzakaya;
        case label_category_japanese:
            return markerJapanese;
        case label_category_noodles:
            return markerNoodles;
        case label_category_western:
            return markerWestern;
        case label_category_yakiniku_teppanyaki:
            return markerYakinikuTeppanyaki;
        default:
            return markerOtherCuisine;
    }
};
